// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ordersList_orders__LmakT {
  min-width: 210px;
  height: fit-content;
  max-height: 90vh;
  overflow: scroll;
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);
  border-radius: 4px;
  margin: 0 17px 0 0px;
  padding: 10px;
  background: #ffffff; }
  .ordersList_orders__LmakT h2 {
    font-weight: 700;
    font-size: 18px;
    line-height: 150%; }
  .ordersList_orders__list__rtMfy {
    height: 100%;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow: auto;
    padding: 20px 0 0 0; }
  .ordersList_orders__item__ZujzN {
    border-bottom: 1px solid #e0e0e0;
    padding: 10px 20px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    cursor: pointer;
    display: flex; }
    .ordersList_orders__item__ZujzN span {
      font-size: 14px;
      color: #666666; }
    .ordersList_orders__item__ZujzN:hover {
      background: rgba(254, 97, 0, 0.1); }

.ordersList_listInput__9e4Hi {
  margin-top: 10px; }

.ordersList_select__zteHE {
  background: rgba(254, 97, 0, 0.1); }
`, "",{"version":3,"sources":["webpack://./src/pages/OrdersViewD3/components/ordersList.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB,EAAA;EAVrB;IAYI,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EAEnB;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;IACd,mBAAmB,EAAA;EAErB;IACE,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa,EAAA;IAPd;MASG,eAAe;MACf,cAAa,EAAA;IAVhB;MAaG,iCAAiC,EAAA;;AAIvC;EACE,gBAAgB,EAAA;;AAElB;EACE,iCAAiC,EAAA","sourcesContent":[".orders {\n  min-width: 210px;\n  height: fit-content;\n  max-height: 90vh;\n  overflow: scroll;\n  background: #ffffff;\n  box-shadow: 0px 0px 8px rgba(68, 87, 104, 0.25);\n  border-radius: 4px;\n  margin: 0 17px 0 0px;\n  padding: 10px;\n  background: #ffffff;\n  h2 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 150%;\n  }\n  &__list {\n    height: 100%;\n    margin-top: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    overflow: auto;\n    padding: 20px 0 0 0;\n  }\n  &__item {\n    border-bottom: 1px solid #e0e0e0;\n    padding: 10px 20px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    cursor: pointer;\n    display: flex;\n    span{\n      font-size: 14px;\n      color:#666666;\n    }\n    &:hover {\n      background: rgba(254, 97, 0, 0.1);\n    }\n  }\n}\n.listInput{\n  margin-top: 10px;\n}\n.select {\n  background: rgba(254, 97, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orders": `ordersList_orders__LmakT`,
	"orders__list": `ordersList_orders__list__rtMfy`,
	"orders__item": `ordersList_orders__item__ZujzN`,
	"listInput": `ordersList_listInput__9e4Hi`,
	"select": `ordersList_select__zteHE`
};
export default ___CSS_LOADER_EXPORT___;
